// 公用地址F
// const BASE_URL = '/iot_license' //测试环境
// const BASE_URL = 'http://127.0.0.1:10886/server' //正式环境
const BASE_URL = '/apiv2/server';
//const BASE_URL = 'http://127.0.0.1:5689' //本地环境/
//const BASE_URL = 'https://kq-test.cometgroup.com.cn/api' //测试环境/
//const BASE_URL = 'https://e-time.comet-cloud.com/api' //生产环境/

export default {
    BASE_URL,
}